import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 100);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    const scrollToSection = (sectionId) => {
        if (location.pathname !== '/') {
            window.location.href = `/#${sectionId}`;
        } else {
            const element = document.getElementById(sectionId);
            if (element) {
                const offsetTop = element.offsetTop - 80;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        }
        setMenuOpen(false);
    };

    return (
        <nav className={`nav ${scrolled ? 'scrolled' : ''}`} id="nav">
            <div className="nav-container">
                <Link to="/" className="logo">
                    <span className="logo-text">Portfolio</span>
                </Link>
                <ul className={`nav-menu ${menuOpen ? 'active' : ''}`} id="navMenu">
                    <li><Link to="/" className="nav-link" onClick={() => scrollToSection('home')}>Home</Link></li>
                    <li><Link to="/" className="nav-link" onClick={() => scrollToSection('about')}>About</Link></li>
                    <li><Link to="/work" className="nav-link">Work</Link></li>
                    <li><Link to="/" className="nav-link" onClick={() => scrollToSection('skills')}>Skills</Link></li>
                    <li><Link to="/" className="nav-link" onClick={() => scrollToSection('contact')}>Contact</Link></li>
                </ul>
                <button
                    className={`menu-toggle ${menuOpen ? 'active' : ''}`}
                    id="menuToggle"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </nav>
    );
};

export default Navigation;
